export default {
  entityList: [],
  currentEntityName: null,
  entityListLoading: false
}
